const getChartTheme = (isDark) => ({
  gridColor: isDark ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.08)",
  tickColor: isDark ? "rgba(255, 255, 255, 0.75)" : "rgba(0, 0, 0, 0.6)",
  borderColor: isDark ? "rgba(255, 255, 255, 0.25)" : "rgba(0, 0, 0, 0.1)",
  panelBg: isDark ? "rgba(255, 255, 255, 0.04)" : "#f7f7f7",
  panelBorder: isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.06)",
  tooltipBg: isDark ? "rgba(30, 40, 55, 0.95)" : "rgba(255, 255, 255, 0.95)",
  tooltipTitle: isDark ? "#fff" : "#333",
  tooltipBody: isDark ? "rgba(255, 255, 255, 0.8)" : "#666",
  tooltipBorder: isDark ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)",
  dataLine: isDark ? "#6EA8FE" : "#0d6efd",
  dataFill: isDark ? "rgba(110, 168, 254, 0.2)" : "rgba(13, 110, 253, 0.15)",
  legendColor: isDark ? "rgba(255, 255, 255, 0.85)" : "#666",
  axisTitleColor: isDark ? "rgba(255, 255, 255, 0.75)" : "#666",
});

export { getChartTheme };
